import script from "./ImageInput.vue?vue&type=script&setup=true&lang=js"
export * from "./ImageInput.vue?vue&type=script&setup=true&lang=js"

import "./ImageInput.vue?vue&type=style&index=0&id=8ff1977c&lang=scss&scoped=true"

import exportComponent from "/var/www/html/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-8ff1977c"]])

export default __exports__